import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$')({
  beforeLoad: ({ params, location }) => {
    const pathname = location.pathname;

    // Handle /sites/templates/:templateId -> /n/settings/templates/:templateId
    const templatesMatch = pathname.match(/^\/sites\/templates\/(.+)$/);
    if (templatesMatch) {
      const templateId = templatesMatch[1];
      throw redirect({
        href: `/n/settings/templates/${templateId}`,
        replace: true,
      });
    }

    // Handle /sites/templates -> /n/settings/templates
    if (pathname === '/sites/templates') {
      throw redirect({
        href: '/n/settings/templates',
        replace: true,
      });
    }

    // Handle /sites/create -> /n/sites?create=true
    if (pathname === '/sites/create') {
      throw redirect({
        href: '/n/sites?create=true',
        replace: true,
      });
    }

    // Default: redirect to /n/sites with the sub-path preserved
    const splat = params._splat || '';
    throw redirect({
      href: `/n/sites/${splat}${location.searchStr}`,
      replace: true,
    });
  },
});
